import { valueToString } from "helpers/Helpers";
import { store } from "index";

/**
 * Facility default currency for report formatting (falls back to CAD).
 */
export function getFacilityCurrencyCode(): string {
  const code = store.getState().facilityStore?.facility?.default_currency_code;
  return (code || "CAD").toUpperCase();
}

/**
 * Format a numeric amount as currency using the facility default currency.
 */
export function formatReportCurrency(amount: number | string): string {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: getFacilityCurrencyCode(),
  }).format(Number(amount));
}

/**
 * Shared report cell/footer display formatter (currency uses facility default).
 */
export function formatReportDisplay(type: string, value: string): string {
  let newValue = value !== null && value !== undefined ? value : "";

  if (!isNaN(Number(newValue)) && newValue !== "") {
    switch (type) {
      case "currency":
        newValue = formatReportCurrency(value);
        break;
      case "decimal":
        newValue = Number(value).toFixed(2);
        break;
      case "percentage":
        newValue = `${Number(value) * 100}%`;
        break;
      default:
        break;
    }
  } else if (type === "string" && newValue !== "") {
    newValue = valueToString(value).replace(/(^\w|\s\w)/g, c => c.toUpperCase());
  }

  return newValue;
}
